/**
 * The CRM-specific children of `list.settings` — the per-provider sync-trigger copy and the
 * section headings the list settings page renders above them.
 *
 * Extracted out of `en.ts` for the same reason as {@link enCrmProviders}: a new CRM must not
 * have to shrink a ratcheted file before it can add a string.
 */
export const enListCrmSettings = {
	hubspot: {
		syncTrigger: {
			title: "Sync Prospects to HubSpot",
			description: "Choose when prospects from this list should be synchronized to HubSpot.",
			DISABLED: "Disabled",
			ON_CAMPAIGN_START: "When campaign starts",
			ON_REPLY: "When prospect replies",
			INHERIT: "Use company default",
			inheritedFrom: "Currently using company setting",
		},
		dealCreationTrigger: {
			title: "Automatic Deal Creation",
			description:
				"Choose when deals should be automatically created in HubSpot for leads from this list.",
			DISABLED: "Off",
			ON_RESPONSE: "On Response",
			ON_POSITIVE_RESPONSE: "On Positive Response",
			INHERIT: "Use company default",
			inheritedFrom: "Currently using company setting",
		},
		leadSyncTrigger: {
			title: "Automatic HubSpot Lead Creation",
			description: "Choose when HubSpot Leads should be created for prospects from this list.",
			DISABLED: "Off",
			ON_RESPONSE: "On Response",
			ON_POSITIVE_RESPONSE: "On Positive Response",
			INHERIT: "Use company default",
			inheritedFrom: "Currently using company setting",
		},
	},
	zoho: {
		syncTrigger: {
			title: "Sync Prospects to Zoho CRM",
			description: "Choose when prospects from this list should be synchronized to Zoho CRM.",
			DISABLED: "Disabled",
			ON_CAMPAIGN_START: "When campaign starts",
			ON_REPLY: "When prospect replies",
			INHERIT: "Use company default",
			inheritedFrom: "Currently using company setting",
		},
		campaignLink: {
			title: "Zoho Campaign Link",
			description:
				"Link this list to a Zoho Campaign. Synced prospects will be added as campaign members.",
		},
	},
	msdynamics: {
		syncTrigger: {
			title: "Sync Prospects to Dynamics 365",
			description: "Choose when prospects from this list should be synchronized to Dynamics 365.",
			DISABLED: "Disabled",
			ON_CAMPAIGN_START: "When campaign starts",
			ON_REPLY: "When prospect replies",
			INHERIT: "Use company default",
			inheritedFrom: "Currently using company setting",
		},
	},
	pipedrive: {
		syncTrigger: {
			title: "Sync Prospects to Pipedrive",
			description: "Choose when prospects from this list should be synchronized to Pipedrive.",
			DISABLED: "Disabled",
			ON_CAMPAIGN_START: "When campaign starts",
			ON_REPLY: "When prospect replies",
			INHERIT: "Use company default",
			inheritedFrom: "Currently using company setting",
		},
		dealCreationTrigger: {
			title: "Automatic Deal Creation",
			description:
				"Choose when deals or leads should be automatically created in Pipedrive for prospects from this list.",
			DISABLED: "Off",
			ON_RESPONSE: "On Response",
			ON_POSITIVE_RESPONSE: "On Positive Response",
			INHERIT: "Use company default",
			inheritedFrom: "Currently using company setting",
		},
	},
	salesforce: {
		syncTrigger: {
			title: "Sync Prospects to Salesforce",
			description: "Choose when prospects from this list should be synchronized to Salesforce.",
			DISABLED: "Disabled",
			ON_CAMPAIGN_START: "When campaign starts",
			ON_REPLY: "When prospect replies",
			INHERIT: "Use company default",
			inheritedFrom: "Currently using company setting",
		},
	},
	// HubSpot settings section
	hubspotSettings: "HubSpot Integration",
	hubspotSettingsDescription: "Configure when prospects should be synchronized to HubSpot",
	// Zoho settings section
	zohoSettings: "Zoho CRM Integration",
	zohoSettingsDescription: "Configure when prospects should be synchronized to Zoho CRM",
	// Pipedrive settings section
	pipedriveSettings: "Pipedrive Integration",
	pipedriveSettingsDescription: "Configure when prospects should be synchronized to Pipedrive",
	// Dynamics 365 settings section
	msdynamicsSettings: "Microsoft Dynamics 365 Integration",
	msdynamicsSettingsDescription: "Configure when prospects should be synchronized to Dynamics 365",
	// Salesforce settings section
	salesforceSettings: "Salesforce Integration",
	salesforceSettingsDescription: "Configure when prospects should be synchronized to Salesforce",
};
